export type AnalysisUploadErrorResponse =
  | {
      errorCode?: string;
      detail?: string;
      file?: string[];
      nonFieldErrors?: string[];
    }
  | string
  | null
  | undefined;

export const getAnalysisUploadErrorMessage = (
  data: AnalysisUploadErrorResponse
): string | undefined => {
  if (!data || typeof data !== "object") {
    return undefined;
  }

  if ("errorCode" in data) {
    switch (data.errorCode) {
      case "INVALID_PDF_FILE":
        return "有効なPDFファイルを選択してください";
      case "UNSUPPORTED_FILE_TYPE":
        return "PDFまたはZIPファイルを選択してください";
      case "FILE_COUNT_EXCEEDED":
        return "ファイル数が超過しています";
      case "INVALID_ZIP_FILE":
      case "ZIP_PASSWORD_PROTECTED":
      case "MIXED_FILE_TYPES":
      case "MULTIPLE_ZIP_FILES":
      case "PDF_COUNT_EXCEEDED":
      case "PDF_FILE_SIZE_EXCEEDED":
      case "PDF_TOTAL_SIZE_EXCEEDED":
        return data.detail;
      default:
        return undefined;
    }
  }

  return data.file?.[0] ?? data.nonFieldErrors?.[0];
};
